import type { EstrategiasFornecedorModel } from "../models/estrategiasFornecedorModel"

export enum EstrategiasFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
}

export type EstrategiasFornecedorAction = {
    type: EstrategiasFornecedorActionsTypes.CARREGAR
    payload: EstrategiasFornecedorModel
}
